import React, { useState } from 'react';
import { Grid, Tooltip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import CommonModal from 'components/commonModal/CommonModal';
import CommonCardDetails from 'components/commonCardDetails/CommonCardDetails';
import { dateFormate } from 'utils/utils';
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";
import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";

function MoreDetails(props) {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [reuploadModal, setReuploadModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

const handleReuploadClick = (doc) => {

  const expired =
    doc.status === "Approved" && new Date(doc.expiryDate) < new Date();

  const formattedDoc = {
    id: doc.id,
    attributeName: doc.complianceName,
    attributeType: doc.attributeType,
    isMandatory: doc.isMandatory,
    isExpiring: doc.isExpiring,

    complianceValue: [
      {
        atributeValue: doc.atributeValue || doc.number || "",
        expiryDate: doc.expiryDate || "",
        status: doc.status,
        isExpired: expired,
        complianceFile: doc.complianceFile || {}
      }
    ]
  };

  setSelectedDoc(formattedDoc);
  setReuploadModal(true);
};

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedImage(null);
    setOpen(false);
  };

  const filteredFiles = props?.details?.filter((val) => val.attributeType === 'File');
  const filteredImages = props?.details?.filter((val) => val.attributeType === 'Image');
  const filteredMultiImages = props?.details?.filter((val) => val.attributeType === 'Multi-Image')
  const filteredTextDocuments = props?.details?.filter((val) => val.attributeType === 'text');

  return (
    <div>
      {props?.details?.length === 0 ? (
        <CommonNoDataFound/>
      ) : (
        <>
      {filteredFiles?.length > 0 && <Typography className='mb5 padding10 font18'>Text With File Documents</Typography>}
      <Grid container direction="row" justifyContent="flex-start" alignItems="start">
        {props?.details?.map((val, idx) => {
         if (val?.attributeType === 'File'){
          return (
           <CommonCardDetails key={val.id} data={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick}/>
          );
        }
        return null})}
        </Grid>

      
        {filteredFiles?.length > 0 && <div className='dashedborder'></div>}
        {filteredImages?.length > 0 && <Typography className='mb5 padding10 font18'>Text With Image</Typography>}
      <Grid container direction="row" justifyContent="flex-start" alignItems="start">
        {props?.details?.map((val, idx) => {
         if (val?.attributeType === 'Image'){
          return (
            <CommonCardDetails key={val.id} data={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick}/> 
          );
        }
        return null})}
        </Grid>

        {filteredImages?.length > 0 && <div className='dashedborder'></div>}
        {filteredMultiImages?.length > 0 && <Typography className='mb5 padding10 font18'>Text With Multi-Image</Typography>}
      <Grid container direction="row" justifyContent="flex-start" alignItems="start">
        {props?.details?.map((val, idx) => {
         if (val?.attributeType === 'Multi-Image'){
          return (
            <CommonCardDetails key={val.id} data={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick}/>
          );
        }
        return null})}
        </Grid>

      

        {filteredMultiImages?.length > 0 && <div className='dashedborder'></div>}
       {filteredTextDocuments?.length > 0 && <Typography className='mb5 padding10 font18'>Text Documents</Typography>}
      <Grid container direction="row" justifyContent="flex-start" alignItems="start">
        {props?.details?.map((val, idx) => {
         if (val?.attributeType === 'text'){
          return (
          <Grid item md={3.7} sm={12} className='borderStyle padding10 m10' key={val.id}>
            
            <Grid item container direction="row" justifyContent="space-between" alignItems="center" className='padding10 backgroundGrey'>
              <Grid item>
                <h1 className="colorBlack font14 fontMedium textOverflow">{val?.complianceName}
                {val?.isMandatory && <span className='colorRed'>*</span>}</h1>
                <p className="font12 fontNormal colorGrey">Number: {val?.atributeValue}</p>
                <p className="font12 fontNormal colorBlue"> <span className='colorBlue'>Exp&nbsp;</span>{dateFormate(val?.expiryDate, 'DD MMMM YYYY')}</p>
              </Grid>
             <Grid item className='dflex' style={{ gap: "8px", alignItems: "center" }}>
                  {val?.status && (
                    <Tooltip title={val?.rejectionReason}>
                      {val?.isExpired === true ? (
                        <Typography className="colorRed flexDirection cursorDefault">
                          Expired (
                          <span className="text-sm text-gray-500">
                            {val.status === "Rejected" && (
                              <ErrorOutlineIcon className="marginRight3 font16" />
                            )}
                            {val?.status}
                          </span>
                          )
                        </Typography>
                      ) : (
                        <Typography className={`${val?.status + 'Btn'} flexDirection`}>
                          {val.status === "Rejected" && (
                            <ErrorOutlineIcon className="marginRight3 font16" />
                          )}
                          {val?.status}
                        </Typography>
                      )}
                    </Tooltip>
                  )}

                  {(val?.status === "Rejected" || val?.isExpired === true) && (
                    <Tooltip title="Reupload">
                      <CloudSyncOutlinedIcon
                        className="cursor"
                        style={{ color: "#2e7d32", fontSize: "20px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReuploadClick(val);
                        }}
                      />
                    </Tooltip>
                  )}
                </Grid>
            </Grid>
          </Grid>
          );
        }
        return null})}

      </Grid>
     {open && 
      <CommonModal
        open={open}
        handleClose={handleClose}
        selectedImage={selectedImage}
      />}
            {reuploadModal && (
              <CommonMultiImageForm
                open={reuploadModal}
                handleClose={() => setReuploadModal(false)}
                reupload={true}
                tabName="driver"
                driverId={props?.driverId}
                details={[selectedDoc]}
                showOtherComponent={true}
                onSuccess={() => {
                  setReuploadModal(false);
                  if (props?.refreshDriverData) {
                    props.refreshDriverData();
                  }
                }}
              />
            )}
      </>
      )}
    </div>
  );
}

export default MoreDetails;
